<template>
    <div class="h-screen w-full flex flex-col items-center justify-center">
        <div class="flex py-12 px-8 w-full max-w-md items-center justify-center gap-8 flex-col h-min md:border">
            <img src="@/assets/img/logo.png" @click="$router.push('/')" class="cursor-pointer w-min h-[3.5rem]" alt="">
            <div class="flex flex-col h-full gap-10 items-start w-full justify-center">
                <div class="flex flex-col gap-3 w-full items-center">
                    <span class="text-2xl tracking-wide font-medium">Forgot Password?</span>
                    <span class="text-sm text-center tracking-wide text-secondary">No worries, we'll send you reset instruction</span>
                </div>
                <div class="w-full flex-col justify-start items-start">
                    <span class="text-sm text-secondary tracking-wide">Email</span>
                    <a-input v-model:value="email" placeholder="Enter your registered email" size="large" class="w-full mt-2" />
                </div>
                <div class="flex flex-col w-full gap-8 items-center justify-center">
                    <a-button :disabled="!email" :loading="isLoading" @click="onSubmit" class="w-full" type="primary" size="large">Reset
                        Password</a-button>
                        <span @click="$router.push('/SignIn')"
                        class="text-primary cursor-pointer text-sm tracking-wide font-medium">Back To Login</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { IconArrowLeft } from "@tabler/icons-vue"
import { message } from 'ant-design-vue';
import { ref } from "vue"
import AuthApi from "../../../api/auth"
import { useRouter } from "vue-router";

const email = ref('')

const router = useRouter()

const isLoading = ref(false)

const authApi = new AuthApi()

const onSubmit = async () => {
    isLoading.value = true
    try {
        const r = await authApi.forgotPassword({ email: email.value })
        router.push('/Forgot/Notif')
    } catch (error) {
        message.error(error?.response?.data?.message ?? 'An error occurred. Please try again later.');
    } finally {
        isLoading.value = false
    }
}
</script>